import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumbItem = _resolveComponent("FKBreadCrumbItem")!
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_ZoneForm = _resolveComponent("ZoneForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, {
      page: _ctx.$t('page.edit'),
      title: _ctx.$t('page.create_edit_zone')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FKBreadCrumbItem, {
          page: _ctx.$t('page.zones'),
          to: "/zones"
        }, null, 8 /* PROPS */, ["page"]),
        _createVNode(_component_FKBreadCrumbItem, {
          page: `${_ctx.zone.name}`,
          to: `/zones/${_ctx.zone.id}`
        }, null, 8 /* PROPS */, ["page", "to"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page", "title"]),
    _createVNode(_component_ZoneForm)
  ], 64 /* STABLE_FRAGMENT */))
}